<template>
    <div>{{ modelValue }}</div>
</template>
<script setup lang="ts">
import type { MapPoint } from '@/objects/generated';

/**
 * This one should have the posibility to input longitude and latitude
 * TODO: We need to add this one with a map picker so we click on a map and it gets the position
 */
const props = defineProps<{
    modelValue: MapPoint | null;
}>();
</script>
